import { createContext, useContext, useMemo } from "react";

export type TabsLayout = "hug" | "fill";
export type TabsColor = "primary";

interface TabsContextType {
  layout: TabsLayout;
  color: TabsColor;
}

const TabsContext = createContext<TabsContextType | undefined>(undefined);

export const useTabsContext = () => {
  const context = useContext(TabsContext);
  if (context === undefined) {
    throw new Error("useTabsContext must be used within a TabsProvider");
  }
  return context;
};

interface TabsProviderProps {
  children: React.ReactNode;
  layout: TabsLayout;
  color: TabsColor;
}

export const TabsProvider = ({ children, layout, color }: TabsProviderProps) => {
  const contextValue = useMemo(() => ({ layout, color }), [layout, color]);
  return <TabsContext.Provider value={contextValue}>{children}</TabsContext.Provider>;
};
